import loading from './loading'
import navbar, { watchNavbarSagas } from './common/navbar'

export const reducers = {
  loading,
  navbar,
}

export const sagas = [...watchNavbarSagas]
